import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Flag from 'react-world-flags';
import '../styles/CountriesPage.css';

const CountriesPage = () => {
  const [activeCountry, setActiveCountry] = useState(null);
  const location = useLocation();

  // URL'deki hash değiştiğinde ülke bilgilerini göster
  useEffect(() => {
    if (location.hash) {
      const countryId = location.hash.substring(1); // # işaretini kaldır
      setActiveCountry(countryId);
      
      // Seçilen ülkeye daha hassas scroll - render sonrası
      setTimeout(() => {
        const element = document.getElementById(countryId);
        if (element) {
          const yOffset = -120; // Üst menü veya sabit header için offset
          const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({
            top: y,
            behavior: 'smooth'
          });
        }
      }, 300); // Render için daha uzun bekleme süresi
    }
  }, [location]);

  // Custom event dinleyicisi
  useEffect(() => {
    const handleCountrySelected = (event) => {
      setActiveCountry(event.detail);
      
      // Seçilen ülkeye scroll yap
      setTimeout(() => {
        const element = document.getElementById(event.detail);
        if (element) {
          const yOffset = -120;
          const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({top: y, behavior: 'smooth'});
        }
      }, 100);
    };
    
    document.addEventListener('countrySelected', handleCountrySelected);
    
    return () => {
      document.removeEventListener('countrySelected', handleCountrySelected);
    };
  }, []);

  // Belgeden alınan ülke verileri
    // CountriesPage.js dosyasında countries array'ini şu şekilde güncelleyin:

const countries = [
  // YENİ EKLENEN ÜLKELER
    {
      id: 'almanya',
      name: 'Almanya',
      code: 'DE',
      relationship: 'Almanya, Türkiye\'nin hem ekonomik hem de toplumsal açıdan en güçlü ilişkiler geliştirdiği ülkelerin başında gelmektedir. Avrupa Birliği\'nin en büyük ekonomisine sahip olan Almanya, aynı zamanda Türkiye\'nin en büyük dış ticaret ortağı ve yurt dışındaki Türk vatandaşlarının en yoğun olarak yaşadığı ülkedir.',
      info: [
        { label: 'Türk Nüfusu', value: '2025 yılı itibarıyla Almanya\'da yaşayan Türk kökenli nüfusun yaklaşık 1,3 milyon olduğu tahmin edilmektedir' },
        { label: 'SGK Anlaşması', value: 'Türkiye ile Almanya arasında 30.04.1964 tarihinde imzalanan Sosyal Güvenlik Anlaşması hâlen geçerlidir' },
        { label: 'Ticaret Hacmi', value: 'Türkiye ile Almanya arasındaki dış ticaret hacmi 2023 yılı itibarıyla 49 milyar Amerikan Dolarını aşmıştır' },
        { label: 'İhracat', value: '2024\'te Türkiye\'nin Almanya\'ya yaptığı ihracat 20,4 milyar USD düzeyindedir' },
        { label: 'Türk Girişimleri', value: 'Almanya\'da faaliyet gösteren 80 binden fazla Türk girişimi bulunmakta, bu işletmeler yaklaşık 500 bin kişiye istihdam sağlamaktadır' },
        { label: 'Asgari Ücret', value: '2025 yılı itibarıyla saatlik brüt asgari ücret 12,82 Euro olarak belirlenmiştir' },
        { label: 'Çalışma Süresi', value: 'Haftalık yasal çalışma süresi genel olarak 40 saat' },
        { label: 'Resmi Dil', value: 'Almanca' },
        { label: 'Nüfus', value: '2025 yılı itibarıyla yaklaşık 84 milyon civarındadır' },
        { label: 'Vize Türü', value: 'D tipi ulusal vize gereklidir. Nitelikli İş Gücü Göç Yasası kapsamında çeşitli kolaylıklar sağlanmaktadır' }
      ]
    },
    {
      id: 'fransa',
      name: 'Fransa',
      code: 'FR',
      relationship: 'Fransa, Avrupa\'nın siyasi ve ekonomik açıdan en etkili ülkelerinden biridir. Türkiye ile Fransa arasındaki diplomatik ilişkiler uzun bir geçmişe sahiptir ve her iki ülke de NATO, OECD ve G20 gibi uluslararası kuruluşlarda ortak üyelikleriyle iş birliğini sürdürmektedir.',
      info: [
        { label: 'Türk Nüfusu', value: '2025 yılı itibarıyla yaklaşık 210.000 Türk kökenli kişi Fransa\'da yaşamaktadır' },
        { label: 'SGK Anlaşması', value: 'Türkiye ile Fransa arasında 1972 yılında imzalanan Sosyal Güvenlik Anlaşması halen yürürlüktedir' },
        { label: 'Ticaret Hacmi', value: '2023 yılı itibarıyla Türkiye ile Fransa arasındaki ticaret hacmi 23 milyar Amerikan Doları seviyesindedir' },
        { label: 'Türk Girişimleri', value: 'Fransa\'da faaliyet gösteren yaklaşık 1.200\'den fazla Türk girişimi bulunmaktadır' },
        { label: 'Türk Yatırımları', value: 'Türkiye\'nin Fransa\'daki doğrudan yatırımlarının toplamı yaklaşık 1,5 milyar Euro seviyesindedir' },
        { label: 'Asgari Ücret', value: '2025 itibarıyla saatlik brüt asgari ücret 11,88 Euro, aylık brüt ücret 1.802 Euro, net maaş ortalama 1.426 Euro' },
        { label: 'Çalışma Süresi', value: 'Haftalık yasal çalışma süresi 35 saattir' },
        { label: 'Resmi Dil', value: 'Fransızca' },
        { label: 'Nüfus', value: '2025 itibarıyla yaklaşık 68 milyon' },
        { label: 'Vize Türü', value: 'D tipi uzun süreli çalışma vizesi ve oturum izni alınması zorunludur' }
      ]
    },
    {
      id: 'hollanda',
      name: 'Hollanda',
      code: 'NL',
      relationship: 'Hollanda, Avrupa\'nın gelişmiş ve liberal ekonomilerinden biridir. Türkiye ile olan ilişkileri 400 yılı aşkın bir geçmişe dayanmaktadır. Hollanda, Türkiye\'nin en büyük doğrudan yatırımcı ülkelerinden biri olmasının yanı sıra, göçmen kökenli Türk topluluğunun güçlü olduğu ülkelerden biridir.',
      info: [
        { label: 'Türk Nüfusu', value: 'Hollanda\'da yaklaşık 500.000 Türk kökenli birey yaşamaktadır' },
        { label: 'SGK Anlaşması', value: 'Türkiye ile Hollanda arasında 1966 yılında imzalanan SGK Anlaşması yürürlüktedir' },
        { label: 'Ticaret Hacmi', value: '2024 yılı itibarıyla Türkiye ile Hollanda arasındaki ticaret hacmi 12,3 milyar Amerikan Doları seviyesindedir' },
        { label: 'Türk İşletmeleri', value: 'Hollanda genelinde faaliyet gösteren 23.000\'den fazla Türk işletmesi bulunmaktadır' },
        { label: 'Türk Yatırımları', value: 'Türkiye\'nin Hollanda\'daki doğrudan yatırımları 2024 yılı itibarıyla yaklaşık 14 milyar USD düzeyindedir' },
        { label: 'Asgari Ücret', value: '2025 yılı itibarıyla saatlik brüt asgari ücret 14,06 Euro' },
        { label: 'Çalışma Süresi', value: 'Haftalık ortalama çalışma süresi 38 saattir' },
        { label: 'Resmi Dil', value: 'Hollandaca' },
        { label: 'Nüfus', value: '2025 yılı itibarıyla yaklaşık 17,9 milyon' },
        { label: 'Vize Türü', value: 'D tipi çalışma vizesi ve oturum izni alınması gereklidir' }
      ]
    },
    {
      id: 'hirvatistan',
      name: 'Hırvatistan',
      code: 'HR',
      relationship: 'Hırvatistan, 2013 yılında Avrupa Birliği\'ne tam üye olmuştur. Türkiye ile Hırvatistan arasındaki siyasi ve ekonomik ilişkiler son yıllarda ivme kazanmış ve ticaret hacmi artmıştır.',
      info: [
        { label: 'Türk Nüfusu', value: 'Hırvatistan\'da 2025 yılı itibarıyla yaklaşık 300 Türk vatandaşı yaşamaktadır' },
        { label: 'SGK Anlaşması', value: 'Türkiye ile Hırvatistan arasında 1998 yılında imzalanan SGK Anlaşması geçerlidir' },
        { label: 'Ticaret Hacmi', value: '2024 yılı itibarıyla iki ülke arasındaki ticaret hacmi yaklaşık 727 milyon Amerikan Doları' },
        { label: 'Ticaret Hedefi', value: 'Hedef, ticaret hacminin 1 milyar dolara çıkarılmasıdır' },
        { label: 'Türk Yatırımları', value: 'Türkiye\'den Hırvatistan\'a yapılan yatırımlar yaklaşık 100 milyon USD seviyesindedir' },
        { label: 'Asgari Ücret', value: '2025 yılı itibarıyla brüt asgari ücret 970 Euro, net asgari ücret yaklaşık 753 Euro' },
        { label: 'Çalışma Süresi', value: 'Haftalık çalışma süresi 40 saattir' },
        { label: 'Resmi Dil', value: 'Hırvatça' },
        { label: 'Nüfus', value: '2025 yılı itibarıyla yaklaşık 3,9 milyon kişi' },
        { label: 'Vize Türü', value: 'D tipi uzun süreli vize ve oturum izni ile ülkede yasal şekilde çalışabilirler' }
      ]
    },
    {
      id: 'ingiltere',
      name: 'İngiltere',
      code: 'GB', // ISO ülke kodu
      relationship: 'Türkiye Cumhuriyeti\'nin ilanından sonra Türkiye-Birleşik Krallık ilişkileri olumlu yönde gelişti. Birleşik Krallık Almanya\'dan sonra Türkiye\'den en büyük miktarda ihracat yapan ülkedir.',
      info: [
        { label: 'Türk Nüfusu', value: 'Yaklaşık 850.000 Türk yaşamaktadır' },
        { label: 'Resmi Dil', value: 'İngilizce' },
        { label: 'Toplam Nüfus', value: '2021 yılı itibariyle 68 milyon' },
        { label: 'SGK Anlaşması', value: 'Türkiye ve İngiltere arasında 1959\'da imzalanan SGK Anlaşması vardır' },
        { label: 'Asgari Ücret Sıralaması', value: '27 ülke arasında yedinci sırada' },
        { label: 'Ekonomi', value: 'Oldukça gelişmiş bir sosyal pazar ve piyasa odaklı bir ekonomidir' }
      ],
      wages: [
        '18 yaşın altındaki çalışanlara saat başı 4.55 £',
        '18 - 20 yaş arası çalışanlara 6.45 £',
        '21 - 24 yaş arası çalışanlara 8.20 £',
        '25 yaş üstü çalışanlara saat başı 8.72 £ ödeniyor'
      ],
      workingHours: 'İngiltere\'de haftalık 40 saat çalışma süresi bulunmaktadır',
      investment: '2002-2019 yılları arasında İngiltere\'ye yapılan Türk yatırımları 2 milyar 969 milyon Dolardır',
      visaTypes: 'İngiltere\'ye çalışmaya gitmek için Ankara Anlaşması vizesi, Tier 1 Yatırımcı ve Girişimci vizeleri, Türk İş Adamı Vizesi ve Türk İşçi vizeleri de bulunmaktadır'
    },
    {
      id: 'isvec',
      name: 'İsveç',
      code: 'SE',
      relationship: 'İsveç\'le ilişkilerimiz, 2013 yılında imzalanan bildiriyle stratejik ortaklık düzeyine ulaşmıştır.',
      info: [
        { label: 'Türk Nüfusu', value: '100,000\'den fazla Türk kökenli yaşamaktadır' },
        { label: 'Ticaret Hacmi', value: 'İsveç ile Türkiye arasındaki ikili ticaret hacmi 2019 yılında 3,011 milyar Dolar' },
        { label: 'SGK Anlaşması', value: 'Türkiye ve İsveç arasında 1978 yılında imzalanan SGK Anlaşması vardır' },
        { label: 'Ekonomi', value: 'Modern bir dağıtım sistemi, mükemmel iç ve dış iletişim ve yetenekli bir işgücüne sahip, ihracat odaklı bir karma ekonomi' },
        { label: 'Asgari Ücret', value: 'İsveç asgari ücret konusunda en iyi ve yüksek maaş veren ülkelerdendir' },
        { label: 'Minimum Kazanç', value: 'Euro bazında 1.720 € sınır bulunmaktadır' },
        { label: 'Çalışma Süresi', value: 'Haftalık çalışma 36 saattir' },
        { label: 'Resmi Dil', value: 'İsveççe' },
        { label: 'Toplam Nüfus', value: '10,4 milyon' },
        { label: 'Vize Türü', value: 'İsveç\'te çalışma vizesi ve oturum izni uygulanmaktadır' }
      ]
    },
    {
      id: 'ispanya',
      name: 'İspanya',
      code: 'ES',
      relationship: 'İspanya, Avrupa\'daki en büyük ticaret ortaklarımızdan ve ülkemize yatırım yapan başlıca AB üyesi ülkelerden biridir.',
      info: [
        { label: 'Türk Nüfusu', value: 'Yaklaşık 6.000 Türk vatandaşı yaşamaktadır' },
        { label: 'Türk Firmaları', value: 'İspanya\'da yatırımcı Türk firmalarının sayısı yaklaşık 85' },
        { label: 'Yatırım Tutarı', value: 'Türkiye\'den İspanya\'ya yapılan doğrudan yatırım tutarı 221 Milyon Dolar' },
        { label: 'SGK Anlaşması', value: 'İspanya ile Türkiye arasında Sosyal Güvenlik Sözleşmesi olmamasına rağmen 16.04.1964 tarihli Avrupa Sosyal Güvenlik Sözleşmesi\'ne taraf olduklarından karşılıklı hizmetleri birleştirebilmektedir' },
        { label: 'Ekonomi', value: 'İspanya kapitalist bir karma ekonomiye sahiptir. Dünyanın 13. büyük ekonomisi ve satın alma gücü paritesi açısından dünyanın en büyük ekonomilerinden biridir' },
        { label: 'Asgari Ücret Sıralaması', value: 'Avrupa\'da bulunan 30 ülke arasında sekizinci sırada' },
        { label: 'Asgari Ücret', value: 'Aylık 1167 euro' },
        { label: 'Çalışma Süresi', value: 'Haftalık çalışma 38 saattir' },
        { label: 'Resmi Dil', value: 'İspanyolca' },
        { label: 'Nüfus', value: '47.329.981 kişi' },
        { label: 'Vize Türü', value: 'İspanya\'da D tipi çalışma vizesi ve oturum izni uygulanmaktadır' }
      ]
    },
    {
      id: 'finlandiya',
      name: 'Finlandiya',
      code: 'FI',
      relationship: 'Türkiye\'nin 2018 yılında yurtdışına toplam yurtdışı doğrudan yatırımda, 36. sıradadır.',
      info: [
        { label: 'Türk Nüfusu', value: 'Finlandiya\'da Türk uyruklularının sayısı 3.820' },
        { label: 'Türk Yatırımları', value: 'Finlandiya\'daki Türk yatırımları 366 milyon Dolar' },
        { label: 'Ekonomi', value: 'Finlandiya ekonomisi, diğer batı ekonomileriyle eşit bir kişi başına üretimle son derece sanayileşmiş, karma bir ekonomidir' },
        { label: 'Asgari Ücret', value: 'Finlandiya\'da net asgari ücret belirlenmemiştir. Buna rağmen ülke geneli çalışanlar aylık 1500€ civarı brüt, 1190€-1300€ net en düşük maaş almaktadır' },
        { label: 'Çalışma Süresi', value: 'Yasalar gereğince düzenli çalışma saati haftada en fazla 40 saat olabilir' },
        { label: 'Resmi Diller', value: 'Fince ve İsveççe' },
        { label: 'Nüfus', value: '5,5 milyon' },
        { label: 'Vize Türü', value: 'Finlandiya\'da D tipi çalışma vizesi ve oturum izni uygulanmaktadır' }
      ]
    },
    {
      id: 'luksemburg',
      name: 'Lüksemburg',
      code: 'LU',
      relationship: 'Küresel finans merkezi olarak öne çıkan Lüksemburg, Avrupa\'nın kalbinde yer alan konumu, düşük enflasyon ve istikrarlı büyüme oranlarıyla, Avrupa\'nın en büyük marketlerine açılan, güçlü ve yüksek gelirli bir ekonomiye sahiptir.',
      info: [
        { label: 'Ekonomi', value: 'Lüksemburg ekonomisi istikrarlı, yüksek gelirli, büyüme hızı yüksek bir ekonomidir' },
        { label: 'Türk Nüfusu', value: '1600 civarında Türk Lüksemburg\'da yaşamaktadır' },
        { label: 'SGK Anlaşması', value: 'Lüksemburg ve Türkiye arasında 2003 yılında SGK anlaşması vardır' },
        { label: 'İşsizlik ve Enflasyon', value: 'Ülkede enflasyon ve işsizlik oranları son derece düşüktür' },
        { label: 'Asgari Ücret Sıralaması', value: 'Avrupa\'da bulunan ülkeler arasında en yüksek asgari ücrete sahiptir' },
        { label: 'Asgari Ücret', value: 'Aylık 2.202 Euro' },
        { label: 'Çalışma Süresi', value: 'Haftalık çalışma saati 37 saattir' },
        { label: 'Resmi Diller', value: 'Lüksemburgca, Almanca ve Fransızca' },
        { label: 'Nüfus', value: '626.108' },
        { label: 'Vize Türü', value: 'Lüksemburg\'da D tipi çalışma vizesi ve oturum izni uygulanmaktadır' }
      ]
    },
    {
      id: 'portekiz',
      name: 'Portekiz',
      code: 'PT',
      relationship: 'Portekiz\'le siyasi ilişkilerimizin "Dostluk, Ticaret ve Seyrüsefer Anlaşması\'nın imzalandığı 1843 yılına kadar uzanan bir geçmişi bulunmaktadır. Türkiye ve Portekiz\'i ortak paydalarda birleştiren olguların ikili ilişkilere olumlu yansımaları olmaktadır.',
      info: [
        { label: 'Türk Nüfusu', value: 'Türkiye\'nin Lizbon Büyükelçiliği konsolosluk şubesine 300 Türk vatandaşı kayıtlıdır' },
        { label: 'Türk Şirketleri', value: 'Portekiz\'de gıda, turizm ve ilaç sanayi sektörlerinde ağırlıklı olarak faaliyet gösteren 17 kadar küçük ölçekli Türk şirketi bulunmaktadır' },
        { label: 'Yatırım Tutarı', value: '2002-2019 (Aralık) yılları arasında ülkemizde yerleşik kişilerce Portekiz\'de yapılan doğrudan yatırımların toplam miktarı 52 milyon dolar' },
        { label: 'Para Birimi ve Asgari Ücret', value: 'Portekiz\'in para birimi Euro\'dur. Portekiz\'in 2021 yılındaki asgari ücreti, aylık 775 Euro' },
        { label: 'Çalışma Süresi', value: 'Çalışma saatleri çalışanlar için günlük en fazla 8 saat ve haftalık en fazla 40 saattir' },
        { label: 'Resmi Dil', value: 'Portekizce. İspanyolcayla benzerliklerinden dolayı halkın bir kısmı İspanyolca konuşabilmektedir veya anlayabilmektedir. İngilizce yaygın olarak bilinmektedir' },
        { label: 'Nüfus', value: '2021 yılında yapılan sayıma göre 10,16 milyon' },
        { label: 'Vize Türü', value: 'Portekiz\'de D tipi çalışma vizesi ve oturum izni uygulanmaktadır' }
      ]
    },
    {
      id: 'romanya',
      name: 'Romanya',
      code: 'RO',
      relationship: 'Ülkemizle Romanya arasında kökleri tarihe dayanan güçlü siyasi, ekonomik, kültürel ve insani bağlar bulunmaktadır. Romanya\'yla ilişkilerimiz üst düzeyde var olan yakın diyalog ve dostluk ilişkileri çerçevesinde sürdürülmektedir.',
      info: [
        { label: 'Nüfus ve Türk Nüfusu', value: 'Ülkenin toplam nüfusu 19.320.000 dir. Türklerin sayısı, toplam nüfusun %0.14\'ünü oluşturacak şekilde 32.098\'dir' },
        { label: 'İhracat', value: 'Romanya\'ya 2015\'te 2,9 milyar dolar olan ihracatın 2020\'de 3,9 milyar dolara yükseldiği görülmüştür' },
        { label: 'Türk Firmaları', value: 'Romanya\'da kayıtlı Türk firması sayısı 16 binden fazla olup, bunun 5 bine yakını aktif olarak faaliyet göstermektedir. Romanya\'da ayrıca çok sayıda şubesi bulunan iki Türk bankası (Credit Europe ve Garanti Bankası) faaliyet göstermektedir' },
        { label: 'SGK Anlaşması', value: 'Türkiye ve Romanya arasında 1966\'da imzalanan SGK anlaşması vardır' },
        { label: 'Asgari Ücret Sıralaması', value: 'Romanya asgari ücret bakımından dünya genelinde 42. Avrupa Birliği ülkeleri arasında ise sondan 3. sırada yer almaktadır' },
        { label: 'Para Birimi ve Asgari Ücret', value: 'Ülkenin para birimi Rumen Leyi\'dir. Romanya\'da asgari ücret 2.550 Rumen Leyi olarak belirlenmiştir' },
        { label: 'Çalışma Süresi', value: 'Romanya\'da en fazla yasal çalışma saati haftada 48 saattir' },
        { label: 'Vize Türü', value: 'Romanya çalışma vizesi oturum vize türü olup D tipi vize başvuru kategorisine girer' }
      ]
    },
    {
      id: 'malta',
      name: 'Malta',
      code: 'MT',
      relationship: 'Malta\'yla ikili ilişkilerimizde başta ekonomik ve ticari konular olmak üzere çeşitli alanlarda iş birliği potansiyelini değerlendirme yönünde karşılıklı ilgi giderek artmaktadır.',
      info: [
        { label: 'Nüfus ve Dünya Sıralaması', value: 'Malta 493.559 kişilik nüfusa sahiptir ve Dünya\'daki tüm ülkeler arasında nüfus sıralamasında 173. sırada yer almaktadır' },
        { label: 'Türk Nüfusu', value: 'Konsolosluk kayıtlarına göre Malta\'da 1200\'e yakın Türk barınmaktadır' },
        { label: 'Ticaret Hacmi', value: 'Malta ve Türkiye arasındaki ticaret hacmi 2008 yılında 1,124 milyar dolara ulaştı. Bu rakam, bir önceki yıla göre %35\'lik bir artış göstermiştir' },
        { label: 'Türk Firmaları', value: '2008 yılı itibarıyla Malta\'da 24 Türk firması faaliyet göstermektedir ve bu firmaların toplam sermayesi 1,3 milyar dolardır' },
        { label: 'Ekonomi', value: 'Malta ekonomi olarak sıkıntı çekmeyen bir ülkedir. Ülkenin gelirlerinin yaklaşık %97\'sini turizm oluşturmaktadır' },
        { label: 'Asgari Ücret Sıralaması', value: 'Avrupa birliği ülkeleri asgari maaş listesine göre Malta 13. sırada yer almaktadır' },
        { label: 'Asgari Ücret', value: 'Malta\'da asgari ücret 792,26 Euro\'dur' },
        { label: 'Çalışma Süresi', value: 'Malta yasalarına göre, çalışma saatleri haftada ortalama 48 saattir' },
        { label: 'Vize Türü', value: 'Malta\'da D tipi çalışma vizesi ve oturum izni uygulanmaktadır' }
      ]
    },
    {
      id: 'italya',
      name: 'İtalya',
      code: 'IT',
      relationship: 'İtalya, her zaman Türkiye\'nin ilk 5 ticaret ortağı arasında yer alır. Avrupa\'da ise 2\'nci büyük ticaret ortağıdır.',
      info: [
        { label: 'Nüfus ve Türk Nüfusu', value: 'Ülkede ikamet eden nüfusun 59 milyon 257 bin 566 olup, ülkedeki Türk sayısı 50 bin' },
        { label: 'Ticaret ve Yatırım', value: 'Türkiye İtalya\'ya son 5 yılda toplam 41 milyar 802 milyon dolarlık ihracat yapmış olup İtalya\'da faaliyet gösteren 53 Türk şirketi bulunmaktadır' },
        { label: 'SGK Anlaşması', value: 'Türkiye ve İtalya arasında 2015\'te imzalanan SGK anlaşması vardır' },
        { label: 'Ekonomi', value: 'İtalya\'da, kişi başına düşen gayrisafi yurt içi hasıla yüksek olup farklı alanlara yönlendirilmiş bir sanayi ekonomisi ve gelişmiş bir altyapı mevcuttur' },
        { label: 'Asgari Ücret', value: 'İtalya, net ücret olarak asgari ücret bedelini 1.662 Euro olarak açıklamıştır' },
        { label: 'Çalışma Süresi', value: 'İtalya\'da haftalık çalışma süresi ortalama 37 saat. Günlük çalışma saati ise 9 saattir' },
        { label: 'Vize Türü', value: 'İtalya\'da D tipi çalışma ve oturum izni uygulanmaktadır' }
      ]
    },
    {
      id: 'isvicre',
      name: 'İsviçre',
      code: 'CH',
      relationship: '1915 yılından itibaren Bern\'de bir Osmanlı Elçisi görev yapmaya başlamıştır. Diplomatik ilişkiler, ilk burada başlamıştır. Osmanlı İmparatorluğu\'ndan Cumhuriyete geçiş sırasında ilişkiler kopmamış ve 1 Kasım 1922 tarihinden itibaren Bern\'deki Elçilik TBMM Hükümeti\'ne bağlanmıştır.',
      info: [
        { label: 'Nüfus ve Türk Nüfusu', value: 'İsviçre nüfusu son rakamlara göre toplam 8.603.900 olup ülkede yaşayan Türk sayısı 130.000' },
        { label: 'Ticaret Hacmi', value: '2021 yılında İsviçre\'ye ihracatımız 1 milyar 256 milyon dolar, İsviçre\'den ithalatımız 3 milyar 56 milyon dolar ve ikili ticaret hacmimiz 4 milyar 313 milyon dolar olmuştur' },
        { label: 'Ekonomi', value: 'Günümüzde İsviçre, Avrupa\'nın tümünün gerçek bankacılık ve finansal kalbidir. Ülkenin ekonomisi, piyasa ilişkilerine ve yabancı sermayenin ciroya dayanmaktadır. Ülkenin ekonomik kalkınmasının temeli bankacılıktır' },
        { label: 'Asgari Ücret', value: 'İsviçre\'de 2021 itibari ile asgari ücret 3500 İsviçre Frank\'ıdır' },
        { label: 'Çalışma Süresi', value: 'Haftalık çalışma 42 saat olarak belirlenmiştir' },
        { label: 'Vize Türü', value: 'İsviçre\'de D tipi çalışma vizesi ve oturum izni uygulanmaktadır' }
      ]
    }
  ];

  // Tıklama ile seçilen ülkenin detaylarını gösterme fonksiyonu
  const toggleCountry = (countryId) => {
    if (activeCountry === countryId) {
      setActiveCountry(null);
    } else {
      setActiveCountry(countryId);
      
      // Render işleminin tamamlanması için kısa bir gecikme ekle
      setTimeout(() => {
        const element = document.getElementById(countryId);
        if (element) {
          const yOffset = -120; // Üst menü veya sabit header için offset
          const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({top: y, behavior: 'smooth'});
        }
      }, 100);
    }
  };

  return (
    <div className="countries-page">
      {/* Hero Banner */}
      <div className="countries-hero">
        <div className="container">
          <h1>Ülkeler</h1>
          <p>PHG Danışmanlık olarak, Avrupa'nın önde gelen ülkelerinde çalışma ve oturum imkanları sunuyoruz. Ülkeler hakkında detaylı bilgilere aşağıdan ulaşabilirsiniz.</p>
        </div>
      </div>

      {/* Countries Grid */}
      <div className="countries-grid-section">
        <div className="container">
          <div className="countries-grid">
            {countries.map(country => (
              <div 
                key={country.id} 
                className={`country-card ${activeCountry === country.id ? 'active' : ''}`}
                onClick={() => toggleCountry(country.id)}
              >
                <div className="country-flag">
                  <Flag code={country.code} height="64" />
                </div>
                <h3>{country.name}</h3>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Countries Detail Section */}
      <div className="countries-detail-section">
        <div className="container">
          {countries.map(country => (
            <div 
              key={country.id}
              id={country.id}
              className={`country-detail ${activeCountry === country.id ? 'active' : ''}`}
            >
              <div className="country-header">
                <div className="country-flag-large">
                  <Flag code={country.code} height="80" />
                </div>
                <h2>{country.name}</h2>
              </div>
              
              <div className="country-body">
                <div className="country-relationship">
                  <p>{country.relationship}</p>
                </div>
                
                <div className="country-info-grid">
                  {country.info.map((item, index) => (
                    <div key={index} className="info-item">
                      <div className="info-label">{item.label}</div>
                      <div className="info-value">{item.value}</div>
                    </div>
                  ))}
                </div>
                
                {country.wages && (
                  <div className="country-section">
                    <h3>Yaş Gruplarına Göre Ücretler</h3>
                    <ul className="wages-list">
                      {country.wages.map((wage, index) => (
                        <li key={index}>{wage}</li>
                      ))}
                    </ul>
                  </div>
                )}
                
                {country.workingHours && (
                  <div className="country-section">
                    <h3>Çalışma Saatleri</h3>
                    <p>{country.workingHours}</p>
                  </div>
                )}
                
                {country.investment && (
                  <div className="country-section">
                    <h3>Türk Yatırımları</h3>
                    <p>{country.investment}</p>
                  </div>
                )}
                
                {country.visaTypes && (
                  <div className="country-section">
                    <h3>Vize Türleri</h3>
                    <p>{country.visaTypes}</p>
                  </div>
                )}
                
                <div className="country-cta">
                  <Link to="/iletisim" className="cta-button">
                    {country.name} Hakkında Danışmanlık Alın
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Contact CTA */}
      <div className="countries-contact-cta">
        <div className="container">
          <h2>Yurtdışında Çalışma ve Yaşam Fırsatları</h2>
          <p>Avrupa'nın farklı ülkelerinde iş ve yaşam kurma konusunda profesyonel destek almak için bizimle iletişime geçin.</p>
          <Link to="/iletisim" className="contact-button">Danışmanlık Talebi Oluşturun</Link>
        </div>
      </div>
    </div>
  );
};

export default CountriesPage;